import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {ErrorSmall} from '@wix/wix-ui-icons-common/on-stage'
import {useExperiments} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {useEffect, useRef} from 'react'
import s from '../../fields.scss'
import {ErrorProps} from './interfaces'

export const Error = ({dataHook, className, error}: ErrorProps) => {
  const {experiments} = useExperiments()
  const newErrorMessagesEnabled = experiments.enabled(ExperimentNames.NewErrorMessages)
  const errorRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (error && errorRef.current) {
      errorRef.current.focus()
    }
  }, [error])

  return error ? (
    <div
      ref={errorRef}
      data-hook={dataHook}
      className={classNames(newErrorMessagesEnabled ? s.newError : s.error, className)}
      role="alert"
      aria-live="assertive"
      tabIndex={-1}
    >
      {newErrorMessagesEnabled ? <ErrorSmall className={s.icon} aria-hidden /> : null}
      {error}
    </div>
  ) : null
}
